/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorMarkup from 'base/components/labrador/Markup';

export const DynamicLabradorMarkup: typeof LabradorMarkup = (props) => {
    return <ErrorBoundary><LabradorMarkup {...props} /></ErrorBoundary>;
}
export type DynamicLabradorMarkupProps = PropsFromComponent<typeof LabradorMarkup>;
